import dividerClasses from "@mui/material/Divider/dividerClasses";
import { typographyResponsive } from "../../styles/utils";
export const MuiListSubheaderTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: Object.assign(Object.assign({}, typographyResponsive(dt, "body2.regular")), { padding: `${dt.inset.squish.medium.variant.vertical} 0`, color: dt.color.onSurface.variant, backgroundColor: dt.color.surface.key, [`.${dividerClasses.root} + &`]: {
                    paddingTop: 0,
                } }),
            gutters: {
                padding: `${dt.inset.squish.medium.variant.vertical} ${dt.inset.squish.medium.variant.horizontal}`,
            },
        },
    };
};
